import React, { lazy } from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
export function Industries() {
  const {
    t
  } = useI18n();
  const industries = [{
    title: t('ind1Title'),
    desc: t('ind1Desc'),
    img: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?q=80&w=800&auto=format&fit=crop'
  }, {
    title: t('ind2Title'),
    desc: t('ind2Desc'),
    img: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=800&auto=format&fit=crop'
  }, {
    title: t('ind3Title'),
    desc: t('ind3Desc'),
    img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=800&auto=format&fit=crop'
  }, {
    title: t('ind4Title'),
    desc: t('ind4Desc'),
    img: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?q=80&w=800&auto=format&fit=crop'
  }];
  return <section className="py-24 md:py-32 relative bg-luxury-espresso" data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-114">
        <Reveal data-id="element-115">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-heading font-medium text-luxury-white" data-id="element-117">
              {t('indTitle')}
            </h2>
            <div className="h-px w-24 bg-luxury-gold/50 md:hidden" data-id="element-118" />
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-119">
          {industries.map((ind, idx) => <Reveal key={idx} delay={idx * 100} data-id="element-120">
              <div className="group relative h-[400px] rounded-3xl overflow-hidden cursor-default" data-id="element-121">
                <div className="absolute inset-0 bg-luxury-espresso" data-id="element-122" />
                <img src={ind.img} alt={ind.title} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-85 transition-all duration-1000 group-hover:scale-105" data-id="element-123" />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-espresso via-luxury-espresso/40 to-transparent" data-id="element-124" />

                <div className="absolute inset-0 p-10 flex flex-col justify-end" data-id="element-125">
                  <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-126">
                    <h3 className="text-2xl font-heading font-medium text-luxury-white mb-3" data-id="element-127">
                      {ind.title}
                    </h3>
                    <p className="text-luxury-white/70 font-light leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-128">
                      {ind.desc}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}